const e = {
  "stage-home__teasers": "stage-home__teasers"
};
export {
  e as default
};
